import React, { useState } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UndoIcon from "@mui/icons-material/Undo";

const VacantCancelDialog = ({
  open,
  onClose,
  onConfirm,
  requestToCancel,
  t = (key) => key,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  if (!requestToCancel) return null;
  
  const formattedDate =
    requestToCancel.daySel && requestToCancel.monthSel && requestToCancel.yearSel
      ? `${String(requestToCancel.daySel).padStart(2, "0")}/${String(requestToCancel.monthSel).padStart(2, "0")}/${requestToCancel.yearSel}`
      : "-";

  const handleConfirm = async () => {
    if (isLoading) return;
    
    setIsLoading(true);
    try {
      await onConfirm();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog 
      open={open} 
      onClose={isLoading ? undefined : onClose} 
      maxWidth="xs" 
      fullWidth
    >
      {/* HEADER UNIFORMATO */}
      <DialogTitle
        sx={{
          bgcolor: "primary.main",
          color: "white",
          display: "flex",
          alignItems: "center",
          gap: 1,
          py: 1.5,
        }}
      >
        <UndoIcon sx={{ color: "white" }} />
        <Typography
          variant="h6"
          component="span"
          sx={{ color: "white", fontWeight: "bold", flex: 1 }}
        >
          {t("Ritirare la candidatura?")}
        </Typography>
        <IconButton onClick={onClose} sx={{ color: "white" }} disabled={isLoading}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      {/* CONTENUTO UNIFORMATO */}
      <DialogContent sx={{ pt: "16px !important" }}>
        <Typography variant="body2" color="text.primary" sx={{ mb: 2 }}>
          {t("Sei sicuro di voler annullare la tua richiesta per questo turno?")}
        </Typography>

        <Paper
          elevation={0}
          sx={{
            p: 2,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 2,
            display: "flex",
            flexDirection: "column",
            gap: 1,
            bgcolor: "#fafafa",
          }}
        >
            <Typography variant="body2" color="text.primary">
            <strong style={{ color: "#2c5282" }}>{t("day")}:</strong> {formattedDate}
          </Typography>
          <Typography variant="body2" color="text.primary">
            <strong style={{ color: "#2c5282" }}>{t("Turno")}:</strong> {requestToCancel.shiftDescription}
          </Typography>
        </Paper>
      </DialogContent>

      {/* FOOTER UNIFORMATO */}
      <DialogActions sx={{ p: 2, borderTop: "1px solid", borderColor: "divider", gap: 1 }}>
        <Button 
          onClick={onClose} 
          variant="outlined" 
          color="inherit" 
          fullWidth
          disabled={isLoading}
        >
          {t("Annulla")}
        </Button>
        <Button 
          onClick={handleConfirm} 
          variant="contained" 
          color="error" 
          fullWidth
          disabled={isLoading}
        >
          {isLoading ? "Caricamento..." : t("Conferma")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

VacantCancelDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  requestToCancel: PropTypes.object,
  t: PropTypes.func,
};

export default VacantCancelDialog;